import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { KetAddMenuPageComponent } from './add-menu-page.component'
import { KetLangsModule } from '../langs'

@NgModule({
  declarations: [KetAddMenuPageComponent],
  entryComponents: [KetAddMenuPageComponent],
  imports: [CommonModule, KetLangsModule],
  exports: [KetAddMenuPageComponent],
})
export class KetAddMenuPageModule {}
